import * as ls from 'local-storage';

export const checkIfAuthorize = () => {
    try {
        const auth = ls('auth');
        return auth === 'authenticated';
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const getAuthToken = () => ls('auth');

const parseJwt = (token) => {
    try {
        const base64 = token
            .split('.')[1]
            .replace(/-/g, '+')
            .replace(/_/g, '/');
        const binary = atob(base64);
        const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
        return JSON.parse(new TextDecoder().decode(bytes));
    } catch (e) {
        return null;
    }
};

export const checkIfAnalyticsExpired = (token) => {
    try {
        const decodedJwt = parseJwt(token?.accessToken);

        if (decodedJwt?.exp * 1000 < Date.now()) {
            return true;
        }

        return false;
    } catch (error) {
        console.error(error);
        return false;
    }
};
